window.Vivense = window.Vivense || {};

Vivense.googleLogin = (function($) {

    var exports = {};

    function gtaEvent(){
        dataLayer.push({
            'Category':'Membership',
            'Action':'Login',
            'Label':' Successful / Facebook',
            'event':'gaEvent'
        });
    }

    function relatedEvent(key){
        dataLayer.push({
            event: "vlEvent",
            vl_label: "VL-Login",
            vl_userID:key
        });
    }

    function pushFormErrorGtaEvent(message){
        dataLayer.push({
            'Category':'Membership',
            'Action':'Login Error',
            'Label': message,
            'event':'gaEvent'
        });
    }

    function handleGoogleLoginResult(data) {
        if (data.success) {
            gtaEvent();
            relatedEvent(data.email);
            Vivense.loginPopup.finishSuccessfulLogin(data);
        } else {
            pushFormErrorGtaEvent(data.error);
            Vivense.loginPopup.displayLoginError(data);
        }
    }

    function addPrivacyAgreementIfChecked(params) {
        params.push({
            name: 'accept_privacy_agreement',
            value: 1
        });
    }



    function handleGoogleLogin(response) {
        Vivense.loginPopup.disableAllButtons();

        var loginForm = Vivense.loginPopup.getLoginForm();

        var params = loginForm.serializeArray();
        Vivense.loginPopup.addStandardParameters(params);

        for (var i=0; i < params.length; i++) {
            if (params[i].name === 'username') {
                params[i].value = 'Google';
            }

            if (params[i].name === 'password') {
                params[i].value = response.credential;
            }
        }


        addPrivacyAgreementIfChecked(params);

        $.post(loginForm.attr('action'), $.param(params))
            .done(handleGoogleLoginResult)
            .fail(function() {
                Vivense.loginPopup.enableAllButtons();
                Vivense.displayError('Bir hata oluştu, lütfen tekrar deneyin.');
            });
    }

    exports.handleResponse = handleGoogleLogin;

    return exports;

})(jQuery);

jQuery(document).ready(function () {

    var script = document.createElement('script');

    script.src = '//accounts.google.com/gsi/client';
    script.id = 'google-jssdk';
    script.type = 'text/javascript';
    script.onload = function() {

        google.accounts.id.initialize({
            client_id: "688591475290-1ak4lrsfb2grrckms3vr1gu5is7dnu75.apps.googleusercontent.com",
            callback: Vivense.googleLogin.handleResponse,
        });


        google.accounts.id.renderButton(
            document.getElementById("google-login-button-hidden"),
            {type:"icon", theme:"filled_black", size:"large", shape:"circle" }  // customization attributes
        );

        var googleLoginButton = jQuery("#google-login-button");
        var googleRenderedHiddenButton = jQuery("#google-login-button-hidden");

        googleLoginButton.click(function (e){
            e.stopPropagation();
            jQuery("#google-login-button-hidden").click();
        });

        googleRenderedHiddenButton.click(function (e){
            e.stopPropagation();
            jQuery("#google-login-button-hidden").children("div").children("div").children("div").click();
        });

        googleRenderedHiddenButton.children("div").children("div").children("div").click(function (e){
            e.stopPropagation();
        });
    };

    document.head.appendChild(script);

});